import React, { useRef, useState, useEffect, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import commonDatas  from '../../apps/CommonDatas'
import './Fish.css';


export function Fish () {
  const isInited = useRef(false);
  const scrollPos = useRef(0);
  const location = useLocation();
  const navigate = useNavigate();
  const [isStartPopup, setIsStartPopup] = useState(false);
  const [isCountDownPopup, setIsCountDownPopup] = useState(false);
  const countDownTimeVal = useRef(0);
  const [countDownTime, setCountDownTime] = useState(0);
  const [isGamePopup, setIsGamePopup] = useState(false);
  const [gameTime, setGameTime] = useState(0);
  const lastGameTime = useRef(0);
  const gameStartTime = useRef(0);
  const gameTapCount = useRef(0);
  const gameTotalTapCount = useRef(0);
  const gameTapTargetCount = useRef(25);
  const gameFishPer1 = useRef(100);
  const gameFishPer2 = useRef(30);
  const gameTargetId = useRef(0);
  const gameBarSpeed = useRef(0.5);
  const [gameObjId, setGameObjId] = useState("");

  const [isFinishGame, setIsFinishGame] = useState(false);
  const [isResultModal, setIsResultModal] = useState(false);
  const [resultModalId, setResultModalId] = useState("");
  const [isTap, setIsTap] = useState(false);
  const [isInRange, setIsInRange] = useState(false);

  const startTimerId = useRef(-1);
  const tapTimerId = useRef(-1);
  const isSuccess = useRef(true);

  let model = 0;
  let typeNo = 0;
  let objTypeId = 0;

  if( location.state != null ){
    model = location.state.model;
    typeNo = location.state.type;

    if(( model === "1_1" ) || ( model === "1_3" ) || ( model === "1_16" )){
        objTypeId = 1;
    }else if(( model === "1_2" ) || ( model === "1_4" ) || ( model === "1_17" )){
        objTypeId = 2;
    }else if(( model === "1_5") || ( model === "1_21" ) ){
        objTypeId = 3;
    }else if(( model === "2_1" ) || ( model === "2_4" ) || ( model === "2_10" )){
        objTypeId = 1;
    }else if(( model === "2_2" ) || ( model === "2_5" ) || ( model === "2_12" )){
        objTypeId = 2;
    }else if(( model === "2_3") || ( model === "2_13" )){
        objTypeId = 3;
    }
  }

  let baseIsError = false;

  const maskObj = commonDatas.getMaskData(model);
  if( maskObj === null ){
    baseIsError = true;
  }

  const lockScroll = function(){
    let htmlObj = document.getElementsByTagName("html")[0];
    let bodyObj = document.getElementsByTagName("body")[0];

    if( htmlObj.scrollTop > bodyObj.scrollTop ){
      scrollPos.current = htmlObj.scrollTop;
    }else{
      scrollPos.current = bodyObj.scrollTop;
    }

    htmlObj.style.overflow = 'hidden';
    htmlObj.scrollTop = scrollPos.current;

    bodyObj.style.overflow = 'hidden';
    bodyObj.scrollTop = scrollPos.current;
  }
  const unlockScroll = function(){
    let htmlObj = document.getElementsByTagName("html")[0];
    htmlObj.style.overflow = 'auto';
    htmlObj.scrollTop = scrollPos.current;

    let bodyObj = document.getElementsByTagName("body")[0];
    bodyObj.style.overflow = 'auto';
    bodyObj.scrollTop = scrollPos.current;
  }
  const closeStartPopup = useCallback(() => {
    setIsStartPopup(false);
    if( startTimerId.current> 0 ){
      clearTimeout(startTimerId.current);
    }
    startTimerId.current = -1;

    unlockScroll();
  }, [startTimerId]);
  const openStartPopup = useCallback(() => {

    setIsStartPopup(true);
    lockScroll();

    startTimerId.current = setTimeout(function(){
      closeStartPopup();
    }, 3000 );
  }, [startTimerId, closeStartPopup]);


  const countdownProc = function(){

    if( countDownTimeVal.current >= 1 ){
      countDownTimeVal.current = countDownTimeVal.current - 1;
      if( countDownTimeVal.current === 3 ){
        playSE("se_countdown");
        if( typeNo === "2" ){
          playSE("se_count2");
        }else{
          playSE("se_count1");
        }
      }
      setCountDownTime(countDownTimeVal.current);

      setTimeout(function(){
        countdownProc();

      }, 1000);
    }else{
      closeCountdownPopup();
    }
  }
  const openCountdownPopup = function(targetId, objId, tapCount, per1, per2, barSpeed){
    if( gameObjId === "" ){
      const htmlObj = document.getElementById("obj_block" + objId);
      const rect = htmlObj.getBoundingClientRect();

      let htmlRootObj = document.getElementsByTagName("html")[0];
      let bodyObj = document.getElementsByTagName("body")[0];
      let offset = 0;

      if( htmlRootObj.scrollTop > bodyObj.scrollTop ){
        offset = htmlRootObj.scrollTop;
      }else{
        offset = bodyObj.scrollTop;
      }
      htmlObj.style.top = offset + rect.y + "px";
      htmlObj.style.left = rect.x + "px";

      countDownTimeVal.current = 6;
      setCountDownTime(countDownTimeVal.current);
      setGameTime(10);
      gameTapCount.current = 0;
      gameTotalTapCount.current = 0;
      gameTapTargetCount.current = tapCount;
      gameFishPer1.current = per1;
      gameFishPer2.current = per2;
      gameTargetId.current = targetId;
      gameBarSpeed.current = barSpeed;
      setGameObjId(objId);

      setIsInRange(false);
      setIsCountDownPopup(true);

      lockScroll();
      countdownProc();

      playSE("se_select");
      if( typeNo === "2" ){
        playSE("se_select2");
      }else{
        playSE("se_select1");
      }
      setTimeout(function(){
        playSE("se_start");
      }, 2000);
      setTimeout(function(){
        playSE("se_start");
      }, 2000);
    }
  }
  const closeCountdownPopup = function(){
    setIsCountDownPopup(false);

    startGame();
  }
  const startGame = function(){
    setIsGamePopup(true);

    gameStartTime.current = (new Date()).getTime();
    lastGameTime.current = 10.0;
    gameProc();
  }
  const gameProc = function(){
    const currentTime = ((new Date()).getTime() - gameStartTime.current) / 1000;

    let lessTime = 10 - currentTime;
    let pastTime = lastGameTime.current - lessTime;

    console.log((pastTime / gameBarSpeed.current));
    gameTapCount.current = gameTapCount.current - (pastTime / gameBarSpeed.current);
    lastGameTime.current = lessTime;
    updateActionBar();

    lessTime = Math.floor(lessTime);
    setGameTime(lessTime);

    if( lessTime <= 0 ){
      lessTime = 0;
      let per = 0;
      if( gameTapCount.current > 0 ){
        const tapPer = ( gameTapCount.current / gameTapTargetCount.current);
        if( tapPer < 0.8 && tapPer > 0.7 ){
          per = gameFishPer1.current;
        }else{
          per = gameFishPer2.current;
        }
      }
      if( 100 * Math.random() < per ){
        isSuccess.current = true;
        setResultModalId(gameTargetId.current);
      }else{
        isSuccess.current = false;
        setResultModalId("");
      }

      playSE("se_finish");
      openFinishPopup();
    }else{
      requestAnimationFrame(gameProc);
    }
    setGameTime(lessTime);
  }

  const updateActionBar = function(){
    const barObj = document.getElementById("action_bar_obj");
    if( barObj != null ){
      const tapPer = (gameTapCount.current / gameTapTargetCount.current);
      const targetPer = 100 * tapPer;
      barObj.style.bottom = targetPer + "%"

      if( tapPer < 0.8 && tapPer > 0.7 ){
        setIsInRange(true);
      }else{
        setIsInRange(false);
      }
    }
  }
  const onTap = function(){
    setIsTap(true);

    gameTotalTapCount.current = gameTotalTapCount.current + 1;
    if( gameTotalTapCount.current % 5 === 1 ){
      playTapSE();
    }
    gameTapCount.current = gameTapCount.current + 1;
    if( gameTapCount.current >= gameTapTargetCount.current ){
      gameTapCount.current = gameTapTargetCount.current;
    }
    updateActionBar();

    if( tapTimerId.current >= 0 ){
        clearTimeout(tapTimerId.current);
        tapTimerId.current = -1;
    }
    tapTimerId.current = setTimeout(function(){
      setIsTap(false);
      tapTimerId.current = -1;
    }, 100);
  }
  const openFinishPopup = function(){
    setIsFinishGame(true);
    lockScroll();

    setTimeout(function(){
      closeFinishPopup();

      openResultModal();
    }, 3000);
  }
  const closeFinishPopup = function(){
    setIsFinishGame(false);
  }
  const openResultModal = function(){
    setIsResultModal(true);
    if( isSuccess.current ){
      playSE("se_success");
    }else{
      playSE("se_failed");
    }
    lockScroll();
  }
  const closeResultModal = function(){
    setIsResultModal(false);
    setIsGamePopup(false);

    const htmlObj = document.getElementById("obj_block" + gameObjId);
    htmlObj.style.top = null;
    htmlObj.style.left = null;

    setGameObjId("");
    setIsInRange(false);

    unlockScroll();
  }
  useEffect(() => {
    if( !isInited.current ){
      isInited.current = true;

      document.getElementsByTagName("html")[0].scrollTop = 0;
      document.body.scrollTop = 0;

      if( baseIsError ){
        navigate("/list");
      }else{
        initTapSE();
        startBGM();
        openStartPopup();
      }
    }
  })

  const startBGM = function(){

    const bgmObj = document.getElementById("bgm" + typeNo);

    bgmObj.currentTime = 0;
    bgmObj.play();
  }
  const stopBGM = function(){

    const bgmObj = document.getElementById("bgm" + typeNo);
    bgmObj.pause();
    bgmObj.currentTime = 0;
  }
  const playSE = function(id){
    const seObj = document.getElementById(id);

    seObj.currentTime = 0;
    seObj.play();
  }

  const audio_ctx = useRef(null);
  const audio_buffer = useRef(null);
  const audio_buffer_node = useRef(null);
  const audio_buffer2 = useRef(null);
  const audio_buffer_node2 = useRef(null);

  const initTapSE = async function(){
    if(!audio_ctx.current){
      audio_ctx.current  = new AudioContext();
    }
    const response = await fetch("./sounds/06_tap_224304.mp3");
    const response_buffer = await response.arrayBuffer();
    audio_ctx.current.decodeAudioData(response_buffer).then((audioBuffer) => {
        audio_buffer.current = audioBuffer;
        setupTapSE();
    });

    let soundPath = "";
    if( typeNo === "2" ){
      soundPath =  "./sounds/06_tap_riku_108516.mp3";
    }else{
      soundPath =  "./sounds/06_tap_sea_327569.mp3";
    }
    const response2 = await fetch(soundPath)
    const response_buffer2 = await response2.arrayBuffer();

    audio_ctx.current.decodeAudioData(response_buffer2).then((audioBuffer) => {
        audio_buffer2.current = audioBuffer;
        setupTapSE();
    });

  }

  const setupTapSE = function(){
    if( audio_buffer.current != null && audio_buffer2.current != null ){
      audio_buffer_node.current = audio_ctx.current.createBufferSource();
      audio_buffer_node.current.buffer = audio_buffer.current;
      audio_buffer_node.current.connect(audio_ctx.current.destination);

      audio_buffer_node2.current = audio_ctx.current.createBufferSource();
      audio_buffer_node2.current.buffer = audio_buffer2.current;
      audio_buffer_node2.current.connect(audio_ctx.current.destination);
    }
  }
  const playTapSE = function(){
    audio_buffer_node.current.start(0);
    audio_buffer_node2.current.start(0);

    setupTapSE();
  }

  return (
    <>
      <div id="fish" className={typeNo === "2" ? "content_wrapper content_type2" : "content_wrapper content_type1"}>
        <div className={isGamePopup ? "content_inner game" : "content_inner"}>
        {typeNo === "1" ?
          <>
            <button id="obj_block1_4_1" className={gameObjId === "1_4_1" ? "obj_block obj_block1_4 obj_block1_4_1 active" : "obj_block obj_block1_4 obj_block1_4_1"} onClick={() => {openCountdownPopup("1_4", "1_4_1", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_4.png" alt="" /></span></button>
            <button id="obj_block1_4_2" className={gameObjId === "1_4_2" ? "obj_block obj_block1_4 obj_block1_4_2 active" : "obj_block obj_block1_4 obj_block1_4_2"} onClick={() => {openCountdownPopup("1_4", "1_4_2", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_4.png" alt="" /></span></button>
            <button id="obj_block1_4_3" className={gameObjId === "1_4_3" ? "obj_block obj_block1_4 obj_block1_4_3 active" : "obj_block obj_block1_4 obj_block1_4_3"} onClick={() => {openCountdownPopup("1_4", "1_4_3", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_4.png" alt="" /></span></button>
            <button id="obj_block1_5_1" className={gameObjId === "1_5_1" ? "obj_block obj_block1_5 obj_block1_5_1 active" : "obj_block obj_block1_5 obj_block1_5_1"} onClick={() => {openCountdownPopup("1_5", "1_5_1", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_5.png" alt="" /></span></button>
            <button id="obj_block1_5_2" className={gameObjId === "1_5_2" ? "obj_block obj_block1_5 obj_block1_5_2 active" : "obj_block obj_block1_5 obj_block1_5_2"} onClick={() => {openCountdownPopup("1_5", "1_5_2", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_5.png" alt="" /></span></button>
            <button id="obj_block1_5_3" className={gameObjId === "1_5_3" ? "obj_block obj_block1_5 obj_block1_5_3 active" : "obj_block obj_block1_5 obj_block1_5_3"} onClick={() => {openCountdownPopup("1_5", "1_5_3", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_5.png" alt="" /></span></button>
            <button id="obj_block1_6_1" className={gameObjId === "1_6_1" ? "obj_block obj_block1_6 obj_block1_6_1 active" : "obj_block obj_block1_6 obj_block1_6_1"} onClick={() => {openCountdownPopup("1_6", "1_6_1", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_6.png" alt="" /></span></button>
            <button id="obj_block1_6_2" className={gameObjId === "1_6_2" ? "obj_block obj_block1_6 obj_block1_6_2 active" : "obj_block obj_block1_6 obj_block1_6_2"} onClick={() => {openCountdownPopup("1_6", "1_6_2", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_6.png" alt="" /></span></button>
            <button id="obj_block1_6_3" className={gameObjId === "1_6_3" ? "obj_block obj_block1_6 obj_block1_6_3 active" : "obj_block obj_block1_6 obj_block1_6_3"} onClick={() => {openCountdownPopup("1_6", "1_6_3", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_6.png" alt="" /></span></button>
            <button id="obj_block1_7_1" className={gameObjId === "1_7_1" ? "obj_block obj_block1_7 obj_block1_7_1 active" : "obj_block obj_block1_7 obj_block1_7_1"} onClick={() => {openCountdownPopup("1_7", "1_7_1", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_7.png" alt="" /></span></button>
            <button id="obj_block1_7_2" className={gameObjId === "1_7_2" ? "obj_block obj_block1_7 obj_block1_7_2 active" : "obj_block obj_block1_7 obj_block1_7_2"} onClick={() => {openCountdownPopup("1_7", "1_7_2", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_7.png" alt="" /></span></button>
            <button id="obj_block1_7_3" className={gameObjId === "1_7_3" ? "obj_block obj_block1_7 obj_block1_7_3 active" : "obj_block obj_block1_7 obj_block1_7_3"} onClick={() => {openCountdownPopup("1_7", "1_7_3", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_7.png" alt="" /></span></button>
            <button id="obj_block1_8_1" className={gameObjId === "1_8_1" ? "obj_block obj_block1_8 obj_block1_8_1 active" : "obj_block obj_block1_8 obj_block1_8_1"} onClick={() => {openCountdownPopup("1_8", "1_8_1", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_8.png" alt="" /></span></button>
            <button id="obj_block1_8_2" className={gameObjId === "1_8_2" ? "obj_block obj_block1_8 obj_block1_8_2 active" : "obj_block obj_block1_8 obj_block1_8_2"} onClick={() => {openCountdownPopup("1_8", "1_8_2", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_8.png" alt="" /></span></button>
            <button id="obj_block1_8_3" className={gameObjId === "1_8_3" ? "obj_block obj_block1_8 obj_block1_8_3 active" : "obj_block obj_block1_8 obj_block1_8_3"} onClick={() => {openCountdownPopup("1_8", "1_8_3", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj1_8.png" alt="" /></span></button>
            {objTypeId === 1 ? <button id="obj_block1_1_1" className={gameObjId === "1_1_1" ? "obj_block obj_block1_1 obj_block1_1_1 active" : "obj_block obj_block1_1 obj_block1_1_1"} onClick={() => {openCountdownPopup("1_1", "1_1_1", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj1_1.png" alt="" /></span></button> : null}
            {objTypeId === 1 ? <button id="obj_block1_1_2" className={gameObjId === "1_1_2" ? "obj_block obj_block1_1 obj_block1_1_2 active" : "obj_block obj_block1_1 obj_block1_1_2"} onClick={() => {openCountdownPopup("1_1", "1_1_2", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj1_1.png" alt="" /></span></button> : null}
            {objTypeId === 2 ? <button id="obj_block1_2_1" className={gameObjId === "1_2_1" ? "obj_block obj_block1_2 obj_block1_2_1 active" : "obj_block obj_block1_2 obj_block1_2_1"} onClick={() => {openCountdownPopup("1_2", "1_2_1", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj1_2.png" alt="" /></span></button> : null}
            {objTypeId === 2 ? <button id="obj_block1_2_2" className={gameObjId === "1_2_2" ? "obj_block obj_block1_2 obj_block1_2_2 active" : "obj_block obj_block1_2 obj_block1_2_2"} onClick={() => {openCountdownPopup("1_2", "1_2_2", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj1_2.png" alt="" /></span></button> : null}
            {objTypeId === 3 ? <button id="obj_block1_3_1" className={gameObjId === "1_3_1" ? "obj_block obj_block1_3 obj_block1_3_1 active" : "obj_block obj_block1_3 obj_block1_3_1"} onClick={() => {openCountdownPopup("1_3", "1_3_1", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj1_3.png" alt="" /></span></button> : null}
            {objTypeId === 3 ? <button id="obj_block1_3_2" className={gameObjId === "1_3_2" ? "obj_block obj_block1_3 obj_block1_3_2 active" : "obj_block obj_block1_3 obj_block1_3_2"} onClick={() => {openCountdownPopup("1_3", "1_3_2", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj1_3.png" alt="" /></span></button> : null}
          </>
           :
          <>
            {objTypeId === 3 ? <button id="obj_block2_3_1" className={gameObjId === "2_3_1" ? "obj_block obj_block2_3 obj_block2_3_1 active" : "obj_block obj_block2_3 obj_block2_3_1"} onClick={() => {openCountdownPopup("2_3", "2_3_1", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj2_3.png" alt="" /></span></button> : null}
            {objTypeId === 3 ? <button id="obj_block2_3_2" className={gameObjId === "2_3_2" ? "obj_block obj_block2_3 obj_block2_3_2 active" : "obj_block obj_block2_3 obj_block2_3_2"} onClick={() => {openCountdownPopup("2_3", "2_3_2", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj2_3.png" alt="" /></span></button> : null}
            <button id="obj_block2_4_1" className={gameObjId === "2_4_1" ? "obj_block obj_block2_4 obj_block2_4_1 active" : "obj_block obj_block2_4 obj_block2_4_1"} onClick={() => {openCountdownPopup("2_4", "2_4_1", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj2_4.png" alt="" /></span></button>
            <button id="obj_block2_4_2" className={gameObjId === "2_4_2" ? "obj_block obj_block2_4 obj_block2_4_2 active" : "obj_block obj_block2_4 obj_block2_4_2"} onClick={() => {openCountdownPopup("2_4", "2_4_2", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj2_4.png" alt="" /></span></button>
            <button id="obj_block2_5_1" className={gameObjId === "2_5_1" ? "obj_block obj_block2_5 obj_block2_5_1 active" : "obj_block obj_block2_5 obj_block2_5_1"} onClick={() => {openCountdownPopup("2_5", "2_5_1", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj2_5.png" alt="" /></span></button>
            <button id="obj_block2_5_2" className={gameObjId === "2_5_2" ? "obj_block obj_block2_5 obj_block2_5_2 active" : "obj_block obj_block2_5 obj_block2_5_2"} onClick={() => {openCountdownPopup("2_5", "2_5_2", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj2_5.png" alt="" /></span></button>
            <button id="obj_block2_6_1" className={gameObjId === "2_6_1" ? "obj_block obj_block2_6 obj_block2_6_1 active" : "obj_block obj_block2_6 obj_block2_6_1"} onClick={() => {openCountdownPopup("2_6", "2_6_1", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj2_6.png" alt="" /></span></button>
            <button id="obj_block2_6_2" className={gameObjId === "2_6_2" ? "obj_block obj_block2_6 obj_block2_6_2 active" : "obj_block obj_block2_6 obj_block2_6_2"} onClick={() => {openCountdownPopup("2_6", "2_6_2", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj2_6.png" alt="" /></span></button>
            <button id="obj_block2_7_1" className={gameObjId === "2_7_1" ? "obj_block obj_block2_7 obj_block2_7_1 active" : "obj_block obj_block2_7 obj_block2_7_1"} onClick={() => {openCountdownPopup("2_7", "2_7_1", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj2_7.png" alt="" /></span></button>
            <button id="obj_block2_7_2" className={gameObjId === "2_7_2" ? "obj_block obj_block2_7 obj_block2_7_2 active" : "obj_block obj_block2_7 obj_block2_7_2"} onClick={() => {openCountdownPopup("2_7", "2_7_2", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj2_7.png" alt="" /></span></button>
            <button id="obj_block2_8_1" className={gameObjId === "2_8_1" ? "obj_block obj_block2_8 obj_block2_8_1 active" : "obj_block obj_block2_8 obj_block2_8_1"} onClick={() => {openCountdownPopup("2_8", "2_8_1", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj2_8.png" alt="" /></span></button>
            <button id="obj_block2_8_2" className={gameObjId === "2_8_2" ? "obj_block obj_block2_8 obj_block2_8_2 active" : "obj_block obj_block2_8 obj_block2_8_2"} onClick={() => {openCountdownPopup("2_8", "2_8_2", 25, 100, 30, 0.5);}}><span><img src="./images/fish/img_obj2_8.png" alt="" /></span></button>
            {objTypeId === 1 ? <button id="obj_block2_1_1" className={gameObjId === "2_1_1" ? "obj_block obj_block2_1 obj_block2_1_1 active" : "obj_block obj_block2_1 obj_block2_1_1"} onClick={() => {openCountdownPopup("2_1", "2_1_1", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj2_1.png" alt="" /></span></button> : null}
            {objTypeId === 1 ? <button id="obj_block2_1_2" className={gameObjId === "2_1_2" ? "obj_block obj_block2_1 obj_block2_1_2 active" : "obj_block obj_block2_1 obj_block2_1_2"} onClick={() => {openCountdownPopup("2_1", "2_1_2", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj2_1.png" alt="" /></span></button> : null}
            {objTypeId === 2 ? <button id="obj_block2_2_1" className={gameObjId === "2_2_1" ? "obj_block obj_block2_2 obj_block2_2_1 active" : "obj_block obj_block2_2 obj_block2_2_1"} onClick={() => {openCountdownPopup("2_2", "2_2_1", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj2_2.png" alt="" /></span></button> : null}
            {objTypeId === 2 ? <button id="obj_block2_2_2" className={gameObjId === "2_2_2" ? "obj_block obj_block2_2 obj_block2_2_2 active" : "obj_block obj_block2_2 obj_block2_2_2"} onClick={() => {openCountdownPopup("2_2", "2_2_2", 25, 80, 30, 0.25);}}><span><img src="./images/fish/img_obj2_2.png" alt="" /></span></button> : null}
          </>
        }
        </div>

        {!isCountDownPopup && !isFinishGame && !isResultModal && !isGamePopup ?
          <Link to="/list" className="btn_back" state={{type: typeNo}} onClick={() => {stopBGM()}}><img src="./images/fish/btn_back.png" width="100%" alt="もどる" /></Link>
            :
          <div className="timer_block"><img src={"./images/fish/c" + typeNo + "_" + gameTime + ".png"} width="100%" alt="" /></div>
        }
        {isGamePopup ?
          <div className="action_bar_wrapper">
            <div class="action_bar_obj_wrapper">
              <div id="action_bar_obj" className="action_bar_obj"></div>
            </div>
          </div>
        :
          null
        }

        {isStartPopup ?
          <div className="start_popup overlay" onClick={() => {closeStartPopup()}}>
            <div className="popup_inner">
              <div className="popup_image">{typeNo === "2" ?
                <img src="./images/fish/img_start2.png" width="100%" alt="いきものをタップして狩りをはじめよう" />
                  :
                <img src="./images/fish/img_start1.png" width="100%" alt="いきものをタップして釣りをはじめよう" />
              }</div>
            </div>
          </div>
        : null}
        {isCountDownPopup ?
          countDownTime <= 3 ?
            <div className="countdown_popup overlay">
              <div className="popup_inner">
                <div className="popup_image"><img src={"./images/fish/img_start" + typeNo + "_" + countDownTime + ".png"} width="100%" alt="" /></div>
              </div>
            </div>
          :
            <div className="countdown_popup">
              <div className="popup_inner">
                <div className="popup_start_image"><img src={typeNo === "2" ? "./images/fish/img_start_popup2.png" : "./images/fish/img_start_popup1.png"} width="100%" alt="10秒間でたくさん●をタップしよう" /></div>
              </div>
            </div>
        : null}
        {isGamePopup ?
          <div className="game_popup">

            <div className="active_bar">
            </div>
            <button className={isTap ? "btn_tap active" : "btn_tap"} onClick={() => {onTap()}}>
              <img src={typeNo === "2" ? "./images/fish/btn_tap2.png" :  "./images/fish/btn_tap1.png"} width="100%" alt="" />
            </button>
          </div>
        : null}
        {isFinishGame ?
          <div className="finish_popup overlay">
            <div className="popup_inner">
              <div className="popup_image"><img src={typeNo === "2" ? "./images/fish/img_finish2.png" : "./images/fish/img_finish1.png"} width="100%" alt="" /></div>
            </div>
          </div>
        : null}
        {isResultModal ?
          <div className="result_popup overlay">
            <div className="popup_inner">
              {resultModalId !== "" ?
                  <div className="popup_image"><img src={"./images/fish/img_success" + resultModalId + ".png"} width="100%" alt="" /></div>
                :
                  <div className="popup_image"><img src="./images/fish/img_failed.png" width="100%" alt="" /></div>
              }
              <button className="btn_close" onClick={(e) => {e.preventDefault(); closeResultModal()}} ><img src="./images/fish/btn_back.png" width="100%" alt="もどる" /></button>
            </div>
          </div>
        : null}
        {isInRange ?
          <div className="range_effect overlay">
            <img src="./images/fish/effect.png" alt="" />
          </div>
        : null}
      </div>
    </>
  );
};